export default __webpack_public_path__ + "static/media/lovely.0eb08147.png";